import { Menu, Typography, Tooltip, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { loadAttackSurfaceMapping } from '../../../../redux/actions/ioc';
import { TitleAction } from '../../shared-components/TitleAction';
import history from '../../../../redux/history';
import { changeTitle } from '../../../../redux/actions/app';
import Icon, { UserOutlined, PlusOutlined } from '@ant-design/icons';
import { ReactComponent as shared_icon } from '../../../../assets/icons/SharedIcon.svg';
import { ReactComponent as public_icon } from '../../../../assets/icons/public.svg';
import { ReactComponent as attack_surface_mapping_icon } from '../../../../assets/icons/Attack_Surface_Icon.svg';
import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';
import PermissionLookupTable from '../../../../shared-components/PermissionLookupTable';

export function AttackSurfaceMappingSubMenu(props) {
  const scopeIconMapping = {
    USER: <UserOutlined />,
    ORGANISATION: <Icon component={shared_icon} />,
    GLOBAL: <Icon component={public_icon} />,
  };

  const { Title, Text } = Typography;

  const { isKeyOn, setSessionStorage, toggleKey, ...rest } = props;

  const AttackSurfaceMappingIcon = (props) => (
    <Icon component={attack_surface_mapping_icon} />
  );

  const dispatch = useDispatch();
  const attackSurfaceMappingLeftMenuData = useSelector(
    (state) => state.ioc.attackSurfaceMappingLeftMenuData,
  );
  const attackSurfaceMappingLeftMenuStatus = useSelector(
    (state) => state.ioc.attackSurfaceMappingLeftMenuStatus,
  );

  useEffect(() => {
    // dispatch(loadAttackSurfaceMapping());
  }, [window.location]);

  const navigateToSavedItem = (
    recipeType,
    recipeUUID,
    recipeName,
    itemType,
    left_menu_name,
  ) => {
    //itemType is whether it's a recipe or a query
    if (itemType === 'query') {
      history.push(
        `/explore/query-builder/` +
          `?query=${recipeUUID}&left_menu_name=${left_menu_name}`,
      );
    } else if (itemType === 'recipe') {
      history.push(
        `/explore/${recipeType}` +
          `?recipeid=${recipeUUID}&left_menu_name=${left_menu_name}`,
      );
    }
  };

  return (
    <>
      <Menu.SubMenu
        data-cy={`leftMenuSidebarAttackSurfaceMenu`}
        title={
          <TitleAction
            menuKey={'attack-surface-mapping'}
            title={
              <div className={styles.section_title}>
                <div className={styles.border} />
                <AttackSurfaceMappingIcon />
                <Title level={5}>Attack Surface Mapping</Title>
              </div>
            }
            showDownArrow={props.isKeyOn('attack-surface-mapping')}
          />
        }
        className={styles.main_menu_option}
        {...rest}
      >
        <Menu.SubMenu
          data-cy={`leftMenuSidebarDigitalFootprintForDomain`}
          className={styles.first_level_submenu}
          title={
            <TitleAction
              menuKey={'digital-footprint-for-domain'}
              showDownArrow={props.isKeyOn('digital-footprint-for-domain')}
              titleAction={() =>
                props.toggleKey('digital-footprint-for-domain')
              }
              title={
                <Text className={styles.additional_indentation} strong>
                  Digital Footprint For Domain
                </Text>
              }
            />
          }
          key={'digital-footprint-for-domain'}
          onTitleClick={() => props.toggleKey('digital-footprint-for-domain')}
        >
          {attackSurfaceMappingLeftMenuData &&
            attackSurfaceMappingLeftMenuData?.[0]?.children?.map((r, idx) => {
              let menuItems = r.children || [];

              return (
                <Menu.SubMenu
                  data-cy={`leftMenuSidebar-${r.value}`}
                  className={styles.second_level_submenu}
                  key={r.value + '-submenu'}
                  onTitleClick={(e) => {
                    props.toggleKey(r.value + '-submenu');
                  }}
                  title={
                    <TitleAction
                      menuKey={r.left_menu_name}
                      showDownArrow={props.isKeyOn(r.value + '-submenu')}
                      titleAction={() => props.toggleKey(r.value + '-submenu')}
                      title={
                        <div className={styles.secondary_section_title}>
                          <Text className={styles.additional_indentation}>
                            {r.left_menu_name ?? r.label}
                          </Text>
                        </div>
                      }
                      itemType={r.type}
                      itemUUID={r.value}
                      itemLabel={r.label}
                      itemLeftMenuName={r.left_menu_name}
                      is_secondary_parent={true}
                    />
                  }
                >
                  <Menu.Item
                    onClick={() => {
                      dispatch(changeTitle(r.label, null));
                      props.toggleKey(r.value);
                      props.setSessionStorage(r.value);
                    }}
                    key={r.value}
                    disabled={
                      !PermissionLookupTable(r.value, props.mySubscriptionPlan)
                    }
                  >
                    {!PermissionLookupTable(
                      r.value,
                      props.mySubscriptionPlan,
                    ) ? (
                      props.returnSubstituteMenu({
                        type: 'subMenuButton',
                        tooltipMessage: (
                          <>
                            {r.left_menu_name} is not part of this subscription
                            plan. To upgrade your subscription contact us at{' '}
                            <a
                              target="_blank"
                              href="mailto:sales@silentpush.com"
                            >
                              sales@silentpush.com
                            </a>
                            .
                          </>
                        ),
                        menuTitle: (
                          <>
                            Create New <PlusOutlined />
                          </>
                        ),
                        icon: null,
                      })
                    ) : (
                      <Tooltip
                        title={'Create New ' + r.left_menu_name + ' Recipe'}
                        placement={'right'}
                      >
                        <Link
                          to={`/explore/${r.value}?left_menu_name=${r.left_menu_name}`}
                        >
                          <Button
                            onClick={() => {
                              props.setClearRecipe();
                            }}
                            className={styles.add_new_button}
                            type="link"
                          >
                            Create New
                            <PlusOutlined />
                          </Button>
                        </Link>
                      </Tooltip>
                    )}
                  </Menu.Item>

                  {menuItems.map((mi, midx) => (
                    <Menu.Item
                      data-cy="attackSurfaceMappingSubMenuSavedRecipe"
                      onClick={() => {
                        props.setSessionStorage(mi.value);
                        props.toggleKey(mi.value + '-savedRecipe');
                      }}
                      key={mi.value + '-savedRecipe'}
                      disabled={
                        !PermissionLookupTable(
                          r.value,
                          props.mySubscriptionPlan,
                        )
                      }
                    >
                      {!PermissionLookupTable(
                        r.value,
                        props.mySubscriptionPlan,
                      ) ? (
                        props.returnSubstituteMenu({
                          type: 'innerSubmenuItem',
                          tooltipMessage: (
                            <>
                              {mi?.label} is not part of this subscription plan.
                              To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          ),
                          menuTitle: (
                            <>
                              <span style={{ marginRight: '4px' }}>
                                {scopeIconMapping[mi.scope]}
                              </span>
                              <span>{mi?.label}</span>
                            </>
                          ),
                          icon: null,
                        })
                      ) : (
                        <TitleAction
                          menuKey={mi.value}
                          title={
                            <Tooltip
                              placement="right"
                              title={mi?.label?.length > 20 ? mi?.label : ''}
                            >
                              <div className={styles.secondary_section_title}>
                                <Link
                                  to={
                                    `/explore/${r.value}` +
                                    `?recipeid=${mi.value}&left_menu_name=${r.label}`
                                  }
                                  className={styles.additional_indentation}
                                >
                                  <span style={{ marginRight: '4px' }}>
                                    {scopeIconMapping[mi.scope]}
                                  </span>
                                  <span>
                                    {mi?.label?.length > 20
                                      ? mi?.label?.substr(0, 20) + '...'
                                      : mi?.label}
                                  </span>
                                </Link>
                              </div>
                            </Tooltip>
                          }
                        />
                      )}
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              );
            })}
        </Menu.SubMenu>

        <Menu.SubMenu
          data-cy={`leftMenuSidebarPotentialVulnerabilities`}
          className={styles.first_level_submenu}
          title={
            <TitleAction
              menuKey={'potential-vulnerabilities'}
              showDownArrow={props.isKeyOn('potential-vulnerabilities')}
              titleAction={() => props.toggleKey('potential-vulnerabilities')}
              title={
                <Text className={styles.additional_indentation} strong>
                  Potential Vulnerabilities
                </Text>
              }
            />
          }
          onTitleClick={(e) => {
            props.toggleKey('potential-vulnerabilities');
          }}
          key={'potential-vulnerabilities'}
        >
          {attackSurfaceMappingLeftMenuData &&
            attackSurfaceMappingLeftMenuData?.[1]?.children?.map((r, idx) => {
              let menuItems = r.children || [];

              return (
                <Menu.SubMenu
                  data-cy={`leftMenuSidebar-${r.value}`}
                  className={styles.second_level_submenu}
                  key={r.value + '-submenu'}
                  onTitleClick={(e) => {
                    props.toggleKey(r.value + '-submenu');
                  }}
                  title={
                    <TitleAction
                      menuKey={r.left_menu_name}
                      showDownArrow={props.isKeyOn(r.value + '-submenu')}
                      titleAction={() => props.toggleKey(r.value + '-submenu')}
                      title={
                        <div className={styles.secondary_section_title}>
                          <Text className={styles.additional_indentation}>
                            {r.left_menu_name ?? r.label}
                          </Text>
                        </div>
                      }
                      itemType={r.type}
                      itemUUID={r.value}
                      itemLabel={r.label}
                      itemLeftMenuName={r.left_menu_name}
                    />
                  }
                >
                  <Menu.Item
                    data-cy="attackSurfaceMappingSubMenuSavedRecipe"
                    onClick={() => {
                      dispatch(changeTitle(r.label, null));
                      props.toggleKey(r.value);
                      props.setSessionStorage(r.value);
                    }}
                    key={r.value}
                    disabled={
                      !PermissionLookupTable(r.value, props.mySubscriptionPlan)
                    }
                  >
                    {!PermissionLookupTable(
                      r.value,
                      props.mySubscriptionPlan,
                    ) ? (
                      props.returnSubstituteMenu({
                        type: 'subMenuButton',
                        tooltipMessage: (
                          <>
                            {r.left_menu_name} recipe is not part of this
                            subscription plan. To upgrade your subscription
                            contact us at{' '}
                            <a
                              target="_blank"
                              href="mailto:sales@silentpush.com"
                            >
                              sales@silentpush.com
                            </a>
                            .
                          </>
                        ),
                        menuTitle: (
                          <>
                            Create New <PlusOutlined />
                          </>
                        ),
                        icon: null,
                      })
                    ) : (
                      <Tooltip
                        title={'Create New ' + r.left_menu_name + ' Recipe'}
                        placement={'right'}
                      >
                        <Link
                          to={`/explore/${r.value}?left_menu_name=${r.left_menu_name}`}
                        >
                          <Button
                            onClick={() => {
                              props.setClearRecipe();
                            }}
                            className={styles.add_new_button}
                            type="link"
                          >
                            Create New <PlusOutlined />
                          </Button>
                        </Link>
                      </Tooltip>
                    )}
                  </Menu.Item>

                  {menuItems?.map((mi, midx) => (
                    <Menu.Item
                      onClick={() => {
                        props.setSessionStorage(mi.value);
                        props.toggleKey(mi.value + '-savedRecipe');
                      }}
                      key={mi.value + '-savedRecipe'}
                      disabled={
                        !PermissionLookupTable(
                          r.value,
                          props.mySubscriptionPlan,
                        )
                      }
                    >
                      {!PermissionLookupTable(
                        r.value,
                        props.mySubscriptionPlan,
                      ) ? (
                        props.returnSubstituteMenu({
                          type: 'innerSubmenuItem',
                          tooltipMessage: (
                            <>
                              {mi?.label} is not part of this subscription plan.
                              To upgrade your subscription contact us at{' '}
                              <a
                                target="_blank"
                                href="mailto:sales@silentpush.com"
                              >
                                sales@silentpush.com
                              </a>
                              .
                            </>
                          ),
                          menuTitle: (
                            <>
                              <span style={{ marginRight: '4px' }}>
                                {scopeIconMapping[mi.scope]}
                              </span>{' '}
                              <span>{mi?.label}</span>
                            </>
                          ),
                          icon: null,
                        })
                      ) : (
                        <TitleAction
                          menuKey={mi.value}
                          title={
                            <Tooltip
                              placement="right"
                              title={mi?.label?.length > 20 ? mi?.label : ''}
                            >
                              <div className={styles.secondary_section_title}>
                                <Link
                                  to={
                                    `/explore/${r.value}` +
                                    `?recipeid=${mi.value}&left_menu_name=${r.label}`
                                  }
                                  className={styles.additional_indentation}
                                >
                                  <span style={{ marginRight: '4px' }}>
                                    {scopeIconMapping[mi.scope]}
                                  </span>{' '}
                                  <span>
                                    {mi?.label?.length > 20
                                      ? mi?.label?.substr(0, 20) + '...'
                                      : mi?.label}
                                  </span>
                                </Link>
                              </div>
                            </Tooltip>
                          }
                        />
                      )}
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              );
            })}
        </Menu.SubMenu>
      </Menu.SubMenu>
    </>
  );
}
